import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
/*Gid-332
 -> When using packages that rely on Node globals (global, Buffer, process) inside an Angular browser app.
 these libraries i installed which originally written for Node.js and expect global to exist and In browsers, there’s no global object—only window so i write here this window.global ...
 */
(window as any).global = window;